import { List } from './lib/list.js';
customElements.define('cipublic-list', List);
//# sourceMappingURL=cipublic-list.js.map